// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard Layout */
.dashboard-container {
    min-height: 100vh;
    background-color: #f8f9fa;
  }
  
  .main-content {
    min-height: 100vh;
  }
  
  /* Sidebar Styles */
  .sidebar {
    width: 280px;
    background-color: #fff;
    border-right: 1px solid #e9ecef;
    min-height: 100vh;
    transition: width 0.3s ease;
  }
  
  .sidebar.collapsed {
    width: 80px;
  }
  
  .sidebar-content {
    padding: 0;
  }
  
  .sidebar-nav {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .sidebar-item {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    color: #6c757d;
    text-decoration: none;
    border-bottom: 1px solid #f8f9fa;
    transition: all 0.3s ease;
  }
  
  .sidebar-item:hover {
    background-color: #f8f9fa;
    color: #495057;
    text-decoration: none;
  }
  
  .sidebar-item.active {
    background-color: #295478;
    color: white;
  }
  
  .sidebar-icon {
    width: 20px;
    margin-right: 12px;
    text-align: center;
  }
  
  .sidebar-label {
    font-weight: 500;
  }
  
  .sidebar.collapsed .sidebar-label {
    display: none;
  }
  
  /* Dashboard Header */
  .dashboard-header {
    background-color: white;
    border-bottom: 1px solid #e9ecef;
  }
  
  .user-avatar .avatar-circle {
    width: 60px;
    height: 60px;
    background-color: #295478;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.2rem;
  }
  
  .user-info .greeting {
    font-size: 0.9rem;
    margin-bottom: 2px;
  }
  
  .user-info .user-name {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
  }
  
  .notification-icon {
    background-color:#14b4c5;
    color: white;
    width: 45px;
    height: 45px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .notification-icon:hover {
    background-color: #14b4c5;
  }
  
  .notification-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #dc3545;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
  
  /* Dashboard Content */
  .dashboard-content {
    max-width: 1200px;
  }
  
  .dashboard-title {
    color: #333;
    font-weight: 600;
    margin-bottom: 2rem;
  }
  
  /* Stats Cards */
  .stat-card {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 2rem;
    text-align: center;
    transition: box-shadow 0.3s ease;
  }
  
  .stat-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .stat-icon-container {
    margin-bottom: 1.5rem;
  }
  
  .stat-icon-circle {
    width: 60px;
    height: 60px;
    background-color: #f8f9fa;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }
  
  .stat-icon-circle i {
    font-size: 1.5rem;
  }
  
  .stat-value {
    font-size: 2.5rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 0.5rem;
  }
  
  .stat-title {
    color: #6c757d;
    font-weight: 500;
  }
  
  /* Section Titles */
  .section-title {
    color: #333;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }
  
  /* Course Cards */
  .course-card {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 1.5rem;
    transition: box-shadow 0.3s ease;
  }
  
  .course-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .course-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }
  
  .course-content {
    padding: 1.5rem;
  }
  
  .course-rating {
    display: flex;
    align-items: center;
  }
  
  .stars i {
    margin-right: 2px;
    font-size: 0.9rem;
  }
  
  .rating-value {
    color: #6c757d;
    font-weight: 500;
  }
  
  .course-title {
    color: #333;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  .course-progress-info {
    font-size: 0.95rem;
  }
  
  .progress-section {
    margin-top: 1rem;
  }
  
  .progress-bar-container {
    flex-grow: 1;
  }
  
  .custom-progress {
    height: 8px;
    background-color: #e9ecef;
    border-radius: 4px;
  }
  
  .custom-progress .progress-bar {
    background-color: #1e3a5f;
    border-radius: 4px;
  }
  
  .progress-percentage {
    font-size: 0.9rem;
    color: #6c757d;
    font-weight: 500;
    white-space: nowrap;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .sidebar {
      position: fixed;
      top: 0;
      left: -280px;
      height: 100vh;
      z-index: 1050;
      transition: left 0.3s ease;
    }
  
    .sidebar.show-mobile {
      left: 0;
    }
  
    .sidebar.collapsed {
      width: 280px; /* Reset width when hidden on mobile */
    }
  
    .sidebar-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1040;
      display: block;
    }
  
    .main-content {
      margin-left: 0;
    }
  
    .dashboard-header {
      padding: 1rem !important;
    }
  
    .user-avatar .avatar-circle {
      width: 50px;
      height: 50px;
      font-size: 1rem;
    }
  
    .stats-cards .col-md-4 {
      margin-bottom: 1rem;
    }
  
    .course-card .row {
      flex-direction: column;
    }
  
    .course-image {
      height: 150px;
    }
  }
  
  @media (max-width: 576px) {
    .dashboard-content {
      padding: 1rem !important;
    }
  
    .stat-card {
      padding: 1.5rem;
    }
  
    .stat-value {
      font-size: 2rem;
    }
  
    .course-content {
      padding: 1rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/dashboard.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA,mBAAmB;EACnB;IACE,YAAY;IACZ,sBAAsB;IACtB,+BAA+B;IAC/B,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,gCAAgC;IAChC,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,uBAAuB;IACvB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA,sBAAsB;EACtB;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,mBAAmB;EACnB;IACE,WAAW;IACX,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,iBAAiB;EACjB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE;MACE,eAAe;MACf,MAAM;MACN,YAAY;MACZ,aAAa;MACb,aAAa;MACb,0BAA0B;IAC5B;;IAEA;MACE,OAAO;IACT;;IAEA;MACE,YAAY,EAAE,sCAAsC;IACtD;;IAEA;MACE,eAAe;MACf,MAAM;MACN,OAAO;MACP,YAAY;MACZ,aAAa;MACb,8BAA8B;MAC9B,aAAa;MACb,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,wBAAwB;IAC1B;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;EACF","sourcesContent":["/* Dashboard Layout */\n.dashboard-container {\n    min-height: 100vh;\n    background-color: #f8f9fa;\n  }\n  \n  .main-content {\n    min-height: 100vh;\n  }\n  \n  /* Sidebar Styles */\n  .sidebar {\n    width: 280px;\n    background-color: #fff;\n    border-right: 1px solid #e9ecef;\n    min-height: 100vh;\n    transition: width 0.3s ease;\n  }\n  \n  .sidebar.collapsed {\n    width: 80px;\n  }\n  \n  .sidebar-content {\n    padding: 0;\n  }\n  \n  .sidebar-nav {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .sidebar-item {\n    display: flex;\n    align-items: center;\n    padding: 15px 20px;\n    color: #6c757d;\n    text-decoration: none;\n    border-bottom: 1px solid #f8f9fa;\n    transition: all 0.3s ease;\n  }\n  \n  .sidebar-item:hover {\n    background-color: #f8f9fa;\n    color: #495057;\n    text-decoration: none;\n  }\n  \n  .sidebar-item.active {\n    background-color: #295478;\n    color: white;\n  }\n  \n  .sidebar-icon {\n    width: 20px;\n    margin-right: 12px;\n    text-align: center;\n  }\n  \n  .sidebar-label {\n    font-weight: 500;\n  }\n  \n  .sidebar.collapsed .sidebar-label {\n    display: none;\n  }\n  \n  /* Dashboard Header */\n  .dashboard-header {\n    background-color: white;\n    border-bottom: 1px solid #e9ecef;\n  }\n  \n  .user-avatar .avatar-circle {\n    width: 60px;\n    height: 60px;\n    background-color: #295478;\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 1.2rem;\n  }\n  \n  .user-info .greeting {\n    font-size: 0.9rem;\n    margin-bottom: 2px;\n  }\n  \n  .user-info .user-name {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #333;\n  }\n  \n  .notification-icon {\n    background-color:#14b4c5;\n    color: white;\n    width: 45px;\n    height: 45px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .notification-icon:hover {\n    background-color: #14b4c5;\n  }\n  \n  .notification-badge {\n    position: absolute;\n    top: -5px;\n    right: -5px;\n    background-color: #dc3545;\n    color: white;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    font-size: 0.75rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n  }\n  \n  /* Dashboard Content */\n  .dashboard-content {\n    max-width: 1200px;\n  }\n  \n  .dashboard-title {\n    color: #333;\n    font-weight: 600;\n    margin-bottom: 2rem;\n  }\n  \n  /* Stats Cards */\n  .stat-card {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 2rem;\n    text-align: center;\n    transition: box-shadow 0.3s ease;\n  }\n  \n  .stat-card:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .stat-icon-container {\n    margin-bottom: 1.5rem;\n  }\n  \n  .stat-icon-circle {\n    width: 60px;\n    height: 60px;\n    background-color: #f8f9fa;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n  }\n  \n  .stat-icon-circle i {\n    font-size: 1.5rem;\n  }\n  \n  .stat-value {\n    font-size: 2.5rem;\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 0.5rem;\n  }\n  \n  .stat-title {\n    color: #6c757d;\n    font-weight: 500;\n  }\n  \n  /* Section Titles */\n  .section-title {\n    color: #333;\n    font-weight: 600;\n    margin-bottom: 1.5rem;\n  }\n  \n  /* Course Cards */\n  .course-card {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    overflow: hidden;\n    margin-bottom: 1.5rem;\n    transition: box-shadow 0.3s ease;\n  }\n  \n  .course-card:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .course-image {\n    width: 100%;\n    height: 200px;\n    object-fit: cover;\n  }\n  \n  .course-content {\n    padding: 1.5rem;\n  }\n  \n  .course-rating {\n    display: flex;\n    align-items: center;\n  }\n  \n  .stars i {\n    margin-right: 2px;\n    font-size: 0.9rem;\n  }\n  \n  .rating-value {\n    color: #6c757d;\n    font-weight: 500;\n  }\n  \n  .course-title {\n    color: #333;\n    font-weight: 600;\n    margin-bottom: 1rem;\n  }\n  \n  .course-progress-info {\n    font-size: 0.95rem;\n  }\n  \n  .progress-section {\n    margin-top: 1rem;\n  }\n  \n  .progress-bar-container {\n    flex-grow: 1;\n  }\n  \n  .custom-progress {\n    height: 8px;\n    background-color: #e9ecef;\n    border-radius: 4px;\n  }\n  \n  .custom-progress .progress-bar {\n    background-color: #1e3a5f;\n    border-radius: 4px;\n  }\n  \n  .progress-percentage {\n    font-size: 0.9rem;\n    color: #6c757d;\n    font-weight: 500;\n    white-space: nowrap;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .sidebar {\n      position: fixed;\n      top: 0;\n      left: -280px;\n      height: 100vh;\n      z-index: 1050;\n      transition: left 0.3s ease;\n    }\n  \n    .sidebar.show-mobile {\n      left: 0;\n    }\n  \n    .sidebar.collapsed {\n      width: 280px; /* Reset width when hidden on mobile */\n    }\n  \n    .sidebar-overlay {\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100vw;\n      height: 100vh;\n      background: rgba(0, 0, 0, 0.5);\n      z-index: 1040;\n      display: block;\n    }\n  \n    .main-content {\n      margin-left: 0;\n    }\n  \n    .dashboard-header {\n      padding: 1rem !important;\n    }\n  \n    .user-avatar .avatar-circle {\n      width: 50px;\n      height: 50px;\n      font-size: 1rem;\n    }\n  \n    .stats-cards .col-md-4 {\n      margin-bottom: 1rem;\n    }\n  \n    .course-card .row {\n      flex-direction: column;\n    }\n  \n    .course-image {\n      height: 150px;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .dashboard-content {\n      padding: 1rem !important;\n    }\n  \n    .stat-card {\n      padding: 1.5rem;\n    }\n  \n    .stat-value {\n      font-size: 2rem;\n    }\n  \n    .course-content {\n      padding: 1rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
